import * as STD from '@emersya/mpa-std';
import {Modal, Text} from '@emersya/mpa-components';
import * as CM from '@emersya/mpa-components-manager';

export interface IErrorComponentConfiguration extends Modal.Configuration {
};

export class ErrorComponent extends Modal.Component<
	{
		error: string;
		canBeClosed: boolean;
	},
	null
> {

    protected override canBeClosed() : boolean {
		if (!this.data)
			this.component_throwUserError('Missing modal data',{});

		return this.data.canBeClosed;
	};

	protected override onOpen() {
		const text = <Text.Component>this.component_find('@:content.text');

		if (!this.data)
			this.component_throwUserError('Missing modal data',{});

		if (this.data.canBeClosed) {
			this.component_DOM.classList.remove('not-closable');
		} else {
			this.component_DOM.classList.add('not-closable');
		}

		text.update(this.data.error);

		STD.translationsManager.update(this.component_DOM);
	};

	protected override onClose() {
	};

	protected override async onValidate(){
		return await Promise.resolve(null);
	};

	override async component_initialize() {
		await super.component_initialize();
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IErrorComponentConfiguration
	)
	{
		super(descriptor, configuration);
        this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});
	};
};
export namespace NS {
	export const Component = ErrorComponent;
	export type Component = ErrorComponent;
	export type Configuration = IErrorComponentConfiguration;
}
;
import manifestXMLSource                   from './error.xml';
import './error.scss';

CM.Manager.declare({
	id :       'modal-error',
	type :     ErrorComponent,
	manifest : manifestXMLSource
});
